import {
  BREAK_POLICY_MAX_BREAK_DURATION_IN_MINUTES,
  BREAK_POLICY_MAX_SHIFT_DURATION_IN_MINUTES,
  BREAK_POLICY_MIN_BREAK_DURATION_IN_MINUTES,
  BREAK_POLICY_MIN_SHIFT_DURATION_IN_MINUTES,
} from "@clipboard-health/contract-backend-main";

export const MAX_BREAK_POLICY_RULES = 5;

const MIN_SHIFT_DURATION_STEP_IN_HOURS = 0.5;
export const SHIFT_DURATION_HOUR_OPTIONS: number[] = (() => {
  const minHours = BREAK_POLICY_MIN_SHIFT_DURATION_IN_MINUTES / 60;
  const maxHours = BREAK_POLICY_MAX_SHIFT_DURATION_IN_MINUTES / 60;
  const options: number[] = [];
  for (let hours = minHours; hours <= maxHours; hours += MIN_SHIFT_DURATION_STEP_IN_HOURS) {
    options.push(Number(hours.toFixed(1)));
  }
  return options;
})();

const BREAK_DURATION_STEP_IN_MINUTES = 5;
export const BREAK_DURATION_MINUTE_OPTIONS: number[] = (() => {
  const options: number[] = [];
  for (
    let minutes = BREAK_POLICY_MIN_BREAK_DURATION_IN_MINUTES;
    minutes <= BREAK_POLICY_MAX_BREAK_DURATION_IN_MINUTES;
    minutes += BREAK_DURATION_STEP_IN_MINUTES
  ) {
    options.push(minutes);
  }
  return options;
})();
